/// <reference path="../lib/jquery.d.ts" />

export class SiteNavControl {

    private openNavButton: JQuery = $('.navOpenButton');
    private closeNavButton: JQuery = $('.navCloseButton');
    private openSearchButton: JQuery = $('.openSearchButton');
    private initialMenuContent: JQuery = $('[data-initial-menu]');
    private searchContent: JQuery = $('[data-search-menu]');
    private pageWrap: JQuery = $('.pageWrap');
    private siteNav: JQuery = $('.siteNav');
    private overlayCover: JQuery = $('.pageWrap.overlayCover');
    private mainBody: JQuery = $('body');
    private html: JQuery = $('html');
    private videoHolder: JQuery = $('.videoBox');
    private bonusLinks: JQuery = $('#bonusLinksContainer');

    constructor() {
        
        document.addEventListener('click', (event)=>{
            const target = event.target as HTMLTextAreaElement

            let video = this.mainBody.find('.videoBox')
            let school = this.mainBody.find('#schoolPopup') 
            let centre = this.mainBody.find('#centrePopup')
            let filters = this.mainBody.find('#filterModule')
            let tempScrollTop = $(window).scrollTop();

            if (target.matches(".pageWrap.overlayCover.fullNav") ||
                    target.className == video.attr("class"))
            {
                video?.remove();
                this.pageWrap.removeClass("overlayCover");
                this.html.css('overflow', "auto");
                $(window).scrollTop(tempScrollTop);
                this.videoHolder?.remove();
 
                school.hide();
                
                centre.hide();
                
                filters.hide();
                
                this.pageWrap.removeClass("overlayCover");
                
                this.searchContent.hide();
                
                this.siteNav.hide();
            }
        });

        this.openNavButton.on('click', (e)=>{
            let navMinHeightAttribute = this.pageWrap.outerHeight() + "px";
            let banner = this.mainBody.find('.banner__wrapper');
            if (banner && banner.css('display') !== 'none'){
                this.siteNav.css('height','calc(100vh - 64px');
            }
            this.pageWrap.addClass("overlayCover").addClass("fullNav");
            this.siteNav.show();
            this.bonusLinks.show();
            this.initialMenuContent.show();
            this.searchContent.hide();
            this.openSearchButton.show();
            this.mainBody.css('overflow-y', 'hidden');
        });

        this.closeNavButton.on('click', (e) => {
            this.pageWrap.removeClass("overlayCover").removeClass(" fullNav");
            this.searchContent.hide();
            this.siteNav.hide();
            this.mainBody.css('overflow-y', 'auto');
        });

        this.openSearchButton.on('click', (e)=>{
            let navMinHeightAttribute  = this.pageWrap.outerHeight() + "px";
            this.initialMenuContent.hide();
            this.openSearchButton.hide();
            this.searchContent.css('min-height', navMinHeightAttribute).show();
        });

    }
}